<template>
  <section class="section-b-space how-work">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="trending-blog">
            <div class="blog-title">
              <h2>{{ _T(contentHeading) }}</h2>
            </div>
            <div class="how-work" v-html="contentText"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="us-img mb-0 text-right">
            <img :src="contentImage" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'HowItWorksPart',
  props: {
    contentHeading: {
      type: String,
      default: '',
    },
    contentText: {
      type: String,
      default: '',
    },
    contentImage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss">
.how-work {
  ul {
    li {
      padding: calc(#{$px15} + (30 - 15) * ((100vw - #{$px320}) / (1920 - 320)))
        calc(#{$px15} + (28 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
      border-radius: $px10;
      width: 100%;
      transition: 0.5s;
      cursor: pointer;
      &:hover {
        box-shadow: 0 $px8 $px30 rgba($black, 0.15);
        transition: 0.5s;
        h4 {
          color: $color-primary;
          transition: 0.5s;
        }
      }
      + li {
        margin-top: $px30;
      }

      h4 {
        font-weight: bold;
        letter-spacing: 0.7px;
        color: $font-color;
        transition: 0.5s;
      }

      h5 {
        letter-spacing: 0.005em;
        color: $font-color;
        margin-bottom: 0;
      }
      &:hover {
        -webkit-box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.15);
        box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.15);
        -webkit-transition: 0.5s;
        transition: 0.5s;
      }
      strong {
        width: 100%;
        margin-right: 5px;
        color: $color-primary;
      }
    }
    
  }
}
</style>
